import React from 'react';
import { Menu, MenuItem, Box, Typography } from '@mui/material';
import { ActionsMenuProps } from './mui-table-props';
import CustomTooltip from '../custom-tooltip';

const ActionsMenu: React.FC<ActionsMenuProps> = ({
    anchorEl,
    onClose,
    onOptionClick,
    options,
    width = '150px',
}) => {
    return (
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            PaperProps={{
                sx: {
                    width: width,
                    borderRadius: '8px',
                },
            }}
        >
            {options?.map((option) => {
                const content = (
                    <MenuItem
                        key={option?.id}
                        onClick={() => !option?.disabled && onOptionClick(option)}
                        disabled={option?.disabled}
                        sx={{ pointerEvents: option?.disabled ? 'none' : 'auto' }} // to prevent tooltip blocking clicks
                    >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            {option?.src && <img
                                src={option.src}
                                alt={option.label}
                                className="upload-icon"
                            />}
                            <Typography className="option-text">{option.label}</Typography>
                        </Box>
                    </MenuItem>
                );

                return option?.disabled && option?.tooltipText ? (
                    <CustomTooltip key={option?.id} title={option.tooltipText} placement='right'>
                        <div>{content}</div>
                    </CustomTooltip>
                ) : (
                    content
                );
            })}
        </Menu>
    );
};

export default ActionsMenu;
